import { CanActivateFn, ActivatedRouteSnapshot, Router } from '@angular/router';
import { LoginService } from '../pages/login/login.service';
import { inject } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { PermissionService } from '../common/services/permission.service';

const MODULE_PERMISSION_ERROR = 'You do not have the required permissions to access this module.';

export const moduleGuard: CanActivateFn = async (route: ActivatedRouteSnapshot): Promise<boolean> => {
    const loginService = inject(LoginService);
    const permissionService = inject(PermissionService);
    const nzMessageService = inject(NzMessageService);
    const router = inject(Router);
    const userRole: string = loginService.getUserRole();

    const moduleSlug = route.data['moduleSlug'] as string;

    // Only admin users can access module-protected routes
    if (userRole !== 'admin') {
        nzMessageService.error(MODULE_PERMISSION_ERROR, { nzDuration: 5000 });
        return false;
    }

    // If no module slug is specified, just allow admin access
    if (!moduleSlug) {
        return true;
    }

    // Fetch fresh permissions from the API
    const permissions = await permissionService.fetchPermissions();

    // If no permissions (e.g. super admin without RBAC role), allow access
    if (!permissions) {
        return true;
    }

    // If user has no roles assigned (empty permissions), allow navigation
    // The admin layout will show the "No Role Assigned" modal
    if (permissionService.hasNoRoles(permissions)) {
        return true;
    }

    const accessLevel = permissions[moduleSlug];

    // Allow if user has READ or READ_WRITE access
    if (accessLevel === 'READ' || accessLevel === 'READ_WRITE') {
        return true;
    }

    nzMessageService.error(MODULE_PERMISSION_ERROR, { nzDuration: 5000 });
    router.navigateByUrl('/admin-dashboard');
    return false;
};
